import React from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { AuthenticateUser } from '../auth/workflows/AuthenticateUser';
import { ResetPassword } from '../auth/workflows/ResetPassword';
import { LoggingOut } from '../features/logging-out/logging-out';
import { SMSWorkflow } from '../features/compliance/smsWorkflow';
import { LocalState } from '../system/services/localStateManager';
import { AUTH_REDIRECT_URL_KEY } from '../../helpers/client-config';

export const authRoutes: RouteObject[] = [
  {
    path: '/',
    children: [
      {
        path: '/',
        element: <Navigate to="/login" replace />,
      },
      {
        path: 'login',
        element: <AuthenticateUser />,
      },
      {
        path: 'auth/passwords/reset',
        element: <ResetPassword />,
      },
      {
        path: 'logging-out',
        element: <LoggingOut />,
      },
      {
        path: '/sms-workflow',
        element: <SMSWorkflow />,
      },
      {
        path: '*',
        element: window.location.pathname.endsWith('login') ? (
          <AuthenticateUser />
        ) : (
          (() => {
            // Store the current path as the redirect URL before redirecting to login
            LocalState.setItem(
              AUTH_REDIRECT_URL_KEY,
              window.location.pathname + window.location.search,
            );
            return <Navigate to="/login" replace />;
          })()
        ),
      },
    ],
  },
];
